import { useEffect, useState } from "react";
import { listNews } from "./firebase";
import { NEWS as STATIC_NEWS } from "./data";

/**
 * Loads news articles. Tries Firestore first; falls back to the static
 * seed list in data.js when Firestore is empty or unavailable. This keeps
 * the public site usable before any articles have been authored in /admin.
 */
export default function useNews() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const rows = await listNews(100);
        if (!alive) return;
        if (rows && rows.length > 0) {
          setList(rows);
        } else {
          setList(STATIC_NEWS);
        }
      } catch (err) {
        if (!alive) return;
        setError(err);
        setList(STATIC_NEWS);
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  return { list, loading, error };
}
